export var AppOwnership;

(function (AppOwnership) {
  AppOwnership["Standalone"] = "standalone";
  AppOwnership["Expo"] = "expo";
  AppOwnership["Guest"] = "guest";
})(AppOwnership || (AppOwnership = {}));

export var UserInterfaceIdiom;

(function (UserInterfaceIdiom) {
  UserInterfaceIdiom["Handset"] = "handset";
  UserInterfaceIdiom["Tablet"] = "tablet";
  UserInterfaceIdiom["Unsupported"] = "unsupported";
})(UserInterfaceIdiom || (UserInterfaceIdiom = {}));